var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.37 233.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#36a9e1;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_6",
    "data-name": "Capa 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.07,220.32s-9.7,13.51-18.71,9c0,0-3.47,8-18,8.66s-14.9-11.78-14.9-11.78-17.32,1.39-21.82-8,4.5-18.71,4.5-18.71-20.09-5.19-17-18.36,13.52-16.63,13.52-16.63-12.48-8.66-10.4-19.06S88.85,134.4,88.85,134.4s-1.38-21.48,17.67-24.6,50.93,26,56.82,45.73S156.07,220.32,156.07,220.32Z",
    transform: "translate(-68.32 -83.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.93,220.32s9.7,13.51,18.71,9c0,0,3.47,8,18,8.66s14.9-11.78,14.9-11.78,17.32,1.39,21.82-8-4.5-18.71-4.5-18.71,20.09-5.19,17-18.36-13.52-16.63-13.52-16.63,12.48-8.66,10.4-19.06-15.59-11.08-15.59-11.08,1.38-21.48-17.67-24.6-50.93,26-56.82,45.73S243.93,220.32,243.93,220.32Z",
    transform: "translate(-68.32 -83.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,203.84c0-1,0-1.54,0-1.54S200,202.85,200,203.84Z",
    transform: "translate(-68.32 -83.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.63,172.51c-10-37.08-44.69-37.06-57.51-36.72-7.42.21-19.7,22.48-28.73,41.19A40.36,40.36,0,0,0,200,172.51,40.36,40.36,0,0,0,188.61,177c-9-18.71-21.31-41-28.73-41.19-12.82-.34-47.47-.36-57.51,36.72s13.51,36.38,30.83,43c8.07,3.07,15.24,9.44,21.47,15.67-5.62,13.47-10,28.35-10,42.53,0,33.26,34,41.58,55.36,41.58s55.36-8.32,55.36-41.58c0-14.18-4.41-29.06-10-42.53,6.23-6.23,13.4-12.6,21.47-15.67C284.12,208.89,307.68,209.58,297.63,172.51Z",
    transform: "translate(-68.32 -83.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.9,147.57s9,8.31,1.16,19.86S232,170,232,170s-2.31,11.32-12,15.48-20-3.24-20-3.24-10.33,7.4-20,3.24S168,170,168,170s-13.17,9-21-2.54,1.16-19.86,1.16-19.86-18-4.65-12.57-23.81,17-14.53,17-14.53-3.29-12.93,7.57-14.32,15,4.39,15,4.39S178.93,84.75,200,84.75h0c21.07,0,24.88,14.55,24.88,14.55s4.15-5.78,15-4.39,7.57,14.32,7.57,14.32,11.6-4.62,17,14.53S251.9,147.57,251.9,147.57Z",
    transform: "translate(-68.32 -83.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.61,270.27a13.82,13.82,0,0,1-24.72,8.51,22.66,22.66,0,0,1,.42,4.28c0,11.24-9.11,12-20.37,12s-20.36-.73-20.36-12a20,20,0,0,1,.28-3.38,13.83,13.83,0,1,1,3.68-9.41v.1c3.71-5.54,9.67-9.44,16.4-9.44,7.15,0,13.44,4.39,17.07,10.48,0-.37,0-.75,0-1.14a13.83,13.83,0,0,1,27.65,0Z",
    transform: "translate(-68.32 -83.25)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.04,
    y1: 191.53,
    x2: 165.93,
    y2: 183.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.63,
    y1: 191.53,
    x2: 97.33,
    y2: 183.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.48 197.63 130.76 191.34 136.94 197.52"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokito);
export default __webpack_public_path__ + "static/media/brokito.10f1eb3486cf1981e63fba9c35b5dd48.svg";
export { ForwardRef as ReactComponent };